function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.994 0H0v24h23.994V0z",
  fill: "transparent"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.983 18.198H8.038c-.18 0-.36.042-.528.12L2.4 20.814V6h5.566V3.6h-5.56A2.412 2.412 0 0 0 0 6v16.734c0 .414.216.798.564 1.02.192.12.414.18.636.18.18 0 .36-.042.528-.12l6.592-3.216h9.663c1.32 0 2.4-1.08 2.4-2.4v-2.172h-2.4v2.172z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.96 5.4h-2.358V0h-2.4v5.4h-5.398v2.4h5.398v5.4h2.4V7.8H24V5.4h-3.04z"
});

var SvgRegisterTicket = function SvgRegisterTicket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRegisterTicket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/register-ticket.a38fc11e.svg";
export { ForwardRef as ReactComponent };